import PubSub from "underpub-js";

/**
 * OverlayDark
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
var MobileNavOverlay = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$close = this.options.$el.find(".close");
  this.$logo = this.options.$el.find(".logo");

};

/**
 * Init
 * @return {[type]} [description]
 */
MobileNavOverlay.prototype.init = function(){

  var self = this;

  // closing the overlay on click
  this.options.$el.on("click", function(e){

    var $target = $(e.target);

    if(! $target.is(".link")){
      self.hide();

      // deactivate the nav bar
      PubSub.publish("deactivateNavBar");
    }

  });

  PubSub.subscribe("showMobileNavOverlay", function(){
    self.show();
  });

  PubSub.subscribe("hideMobileNavOverlay", function(){
    self.hide();
  });

  this.options.$el.find('#mobile-nav-select-location').on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    PubSub.publish("showLanguageSelectorModal");
  });

};

/**
 * Show
 * @return {[type]} [description]
 */
MobileNavOverlay.prototype.show = function(){

  var self = this;

  this.options.$el.addClass("is-active");

};

/**
 * Hide
 * @return {[type]} [description]
 */
MobileNavOverlay.prototype.hide = function(){

  var self = this;

  this.options.$el.removeClass("is-active");
  self.options.$el.find('.location-selector').removeClass('is-active');

};

export default  MobileNavOverlay;
